import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'
import { TimeSlot } from '@/components/shared/datepicker/model/types'

export const SUBMIT_BUTTON_TEXT = 'Отправить'
export const confirmSubmitHeader = 'Постоянный пропуск'
export const REQUEST_SUCCESS_CREATED = 'Обращение создано'
export const PASS_SUCCESS_CREATED = 'Заказ на пропуск создан'
export const REQUEST_CANCELLED = 'Обращение отменено'
export const PASS_CANCELLED = 'Пропуск отменен'
export const REQUEST_CLOSE_TITLE = 'Закрыть окно создания обращения?'
export const PASS_CLOSE_TITLE = 'Закрыть окно создания пропуска?'
export const REQUEST_CLOSE_MESSAGE =
  'Если вы закроете окно, то заполненные данные не сохранятся'
export const REQUEST_CLOSE_CONFIRM_TEXT = 'Закрыть'
export const REQUEST_CLOSE_CANCEL_TEXT = 'Отмена'

export const confirmSubmitMessagePerson =
  'Вы создаёте постоянный пропуск для личного транспорта, заполненные данные о посетителях будут удалены.'
export const confirmSubmitMessageAuto =
  'Вы создаёте постоянный пропуск для посетителей, заполненные данные на личный транспорт будут удалены.'

export const TIME_SLOTS: TimeSlot[] = [
  {
    id: 'morning',
    startTime: '09:00',
    endTime: '13:00',
    displayText: '09:00 – 13:00'
  },
  {
    id: 'afternoon',
    startTime: '13:00',
    endTime: '17:00',
    displayText: '13:00 – 17:00'
  },
  {
    id: 'evening',
    startTime: '17:00',
    endTime: '21:00',
    displayText: '17:00 – 21:00'
  }
]

export const personsKey = `${RequestTypeAlias.PermanentPassFamily}${RequestTypeAlias.PermanentPassStaff}${RequestTypeAlias.PermanentPassRenter}`
